//Module Keys
let locales = {};

//Merge Views
import main from 'Modules/devices/views/main/lan/en';
import overview from 'Modules/devices/views/overview/lan/en';
import devicesTab from 'Modules/devices/.components/tab/lan/en';
import vidFleetVideo from 'Modules/devices/.components/vidFleetVideo/lan/en';
import bulkPairing from 'Modules/devices/.components/bulkPairing/lan/en';
import bulkActions from 'Modules/devices/.components/bulkActions/lan/en';
import activateSimCard from 'Modules/devices/.components/activateSimCard/lan/en';
import changeSimProvider from 'Modules/devices/.components/changeSimProvider/lan/en';
import importDevices from 'Modules/devices/.components/importDevices/lan/en';
import bulkUnparing from 'Modules/devices/.components/bulkUnpairing/lan/en';
import assignFirmware from 'Modules/devices/.components/assignFirmware/lan/en';
import pulsInfo from 'Modules/devices/.components/pulsInfoTab/lan/en';
import simInfo from 'Modules/devices/.components/simInfoTab/lan/en';
import features from 'Modules/devices/.components/featureTab/lan/en';
import troubleShootingEventsTab from 'Modules/devices/.components/troubleShootingEventsTab/lan/en';
import formatSDCard from 'Modules/devices/.components/formatSDCard/lan/en';
import rebootDevice from 'Modules/devices/.components/rebootDevice/lan/en';
import requestDeviceLog from 'Modules/devices/.components/requestDeviceLog/lan/en';
import messagesOutboxTab from 'Modules/devices/.components/messagesOutboxTab/lan/en';
import editSwapSimCard from 'Modules/devices/.components/editSwapSimCard/lan/en';
import sendCommands from 'Modules/devices/.components/sendCommand/lan/en';
import changePulsCustomer from 'Modules/devices/.components/changePulsCustomer/lan/en';
import changeScript from 'Modules/devices/.components/changeScript/lan/en';
import changeStatus from 'Modules/devices/.components/changeStatus/lan/en';
import moveToOtherAccount from 'Modules/devices/.components/moveToOtherAccount/lan/en';
import markAsRma from 'Modules/devices/.components/markAsRma/lan/en';
import refurbishDevice from 'Modules/devices/.components/refurbishDevice/lan/en';
import associateToGps from 'Modules/devices/views/overview/.components/associateToGps/lan/en';
import notes from 'Modules/devices/.components/notesTab/lan/en';
import createEditNote from 'Modules/devices/.components/notesTab/.components/createEditNote/lan/en';
import deleteNote from 'Modules/devices/.components/notesTab/.components/deleteNote/lan/en';
import revertRma from 'Modules/devices/.components/revertRma/lan/en';
import changeTimezone from 'Modules/devices/.components/changeTimezone/lan/en';
import maintenanceWarnings from 'Modules/devices/.components/maintenanceWarnings/lan/en';
import dailyDeviceAudit from 'Modules/devices/.components/dailyDeviceAudit/lan/en';
import coverageDetails from 'Modules/devices/.components/coverageDetails/lan/en';
import createDiagnosticDevice from 'Modules/devices/.components/createDiagnosticDevice/lan/en';
import userTroubleshooting from 'Modules/devices/.components/userTroubleshooting/lan/en';
import clipRequestTab from 'Modules/devices/.components/clipRequestTab/lan/en';
import createClipRequest from 'Modules/devices/.components/createClipRequest/lan/en';
import deleteClipRequest from 'Modules/devices/.components/deleteClipRequest/lan/en';
import castImportManual from 'Modules/devices/.components/castImportManual/lan/en';

locales = {
    ...locales,
    ...main,
    ...overview,
    ...devicesTab,
    ...vidFleetVideo,
    ...bulkPairing,
    ...bulkActions,
    ...activateSimCard,
    ...changeSimProvider,
    ...importDevices,
    ...bulkUnparing,
    ...assignFirmware,
    ...pulsInfo,
    ...simInfo,
    ...features,
    ...troubleShootingEventsTab,
    ...formatSDCard,
    ...rebootDevice,
    ...requestDeviceLog,
    ...messagesOutboxTab,
    ...editSwapSimCard,
    ...sendCommands,
    ...changePulsCustomer,
    ...changeScript,
    ...changeStatus,
    ...moveToOtherAccount,
    ...markAsRma,
    ...refurbishDevice,
    ...associateToGps,
    ...notes,
    ...createEditNote,
    ...deleteNote,
    ...revertRma,
    ...changeTimezone,
    ...maintenanceWarnings,
    ...dailyDeviceAudit,
    ...coverageDetails,
    ...createDiagnosticDevice,
    ...userTroubleshooting,
    ...clipRequestTab,
    ...createClipRequest,
    ...deleteClipRequest,
    ...castImportManual,
};

export default locales;